import { FC } from "react";
import * as Yup from "yup";
import { SpeckleImportModel } from "../types/SpeckleImportModel";
import SpeckleImportProjectStep from "./SpeckleImportProjectStep";
import SpeckleImportModelStep from "./SpeckleImportModelStep";
import SpeckleImportVersionStep from "./SpeckleImportVersionStep";
import SpeckleImportAccountStep from "./SpeckleImportAccountStep";
import SpeckleImportWorkspaceStep from "components/modules/UploadDialog/SpeckleImportWizard/steps/SpeckleImportWorkspaceStep";

type SpeckleImportStep = {
  validation: Yup.ObjectSchema<
    Partial<Record<keyof SpeckleImportModel, Yup.AnySchema>>
  >;
  component: FC;
};

export const speckleImportSteps: SpeckleImportStep[] = [
  {
    validation: Yup.object().shape({
      connectedAccountId: Yup.string()
        .nullable()
        .required("ConnectedAccountId missing."),
    }),
    component: SpeckleImportAccountStep,
  },
  {
    validation: Yup.object().shape({
      workspaceId: Yup.string().nullable().required("Workspace missing"),
    }),
    component: SpeckleImportWorkspaceStep,
  },
  {
    validation: Yup.object().shape({
      projectId: Yup.string().nullable().required("Project missing."),
    }),
    component: SpeckleImportProjectStep,
  },
  {
    validation: Yup.object().shape({
      modelId: Yup.string().nullable().required("Model missing."),
    }),
    component: SpeckleImportModelStep,
  },
  {
    validation: Yup.object().shape({
      versionId: Yup.string().nullable().required("Version missing."),
    }),
    component: SpeckleImportVersionStep,
  },
];
